import * as t from '../actions/finances';

const defaultState = null;

const financeBalance = (state = defaultState, action) => {
  switch (action.type) {
    case t.BALANCE_PARENT_SUCCESS:
      return action.payload;

    default:
      return state;
  }
};

export default financeBalance;
